import { useCallback } from 'react';
import { Currency } from '../../enums';
function addIfHasValue(target, key, value) {
    if (value === undefined || value === null) {
        return;
    }
    if (typeof value === 'string' && value.trim() === '') {
        return;
    }
    target[key] = value;
}
function resolveEndToEndIdFromPixDetails(pixDetails) {
    const raw = pixDetails.endToEndId;
    if (typeof raw !== 'string') {
        return undefined;
    }
    const trimmed = raw.trim();
    return trimmed === '' ? undefined : trimmed;
}
export function mapPostTransferPixPixBodyToTransferPixV3Api(body) {
    const d = body.pixDetails;
    const endToEndIdFromKeyDetails = resolveEndToEndIdFromPixDetails(d);
    const pixDetails = {
        keyType: d.keyType,
    };
    addIfHasValue(pixDetails, 'key', d.key);
    addIfHasValue(pixDetails, 'counterpartyName', d.counterpartyName);
    addIfHasValue(pixDetails, 'counterpartyDocument', d.counterpartyDocument);
    addIfHasValue(pixDetails, 'counterpartyBank', d.counterpartyBank);
    addIfHasValue(pixDetails, 'counterpartyBankAccount', d.counterpartyBankAccount);
    addIfHasValue(pixDetails, 'counterpartyBankBranch', d.counterpartyBankBranch);
    if (d.counterpartyAccountType !== undefined && d.counterpartyAccountType !== null) {
        pixDetails.counterpartyAccountType = d.counterpartyAccountType;
    }
    addIfHasValue(pixDetails, 'endToEndId', endToEndIdFromKeyDetails);
    addIfHasValue(pixDetails, 'transactionIdentification', d.transactionIdentification);
    addIfHasValue(pixDetails, 'qrCodeType', d.qrCodeType);
    const payload = {
        amount: body.amount ?? 0,
        currency: body.currency ?? Currency.BRL,
        source: body.source,
        credential: body.credential,
        pixDetails,
        confirmDuplicate: body.confirmDuplicate ?? false,
    };
    addIfHasValue(payload, 'description', d.description);
    addIfHasValue(payload, 'endToEndId', endToEndIdFromKeyDetails);
    addIfHasValue(payload, 'accountPayablesId', body.accountPayablesId);
    return payload;
}
export function useMapPostTransferPixV3() {
    const mapPixBodyToV3Api = useCallback(mapPostTransferPixPixBodyToTransferPixV3Api, []);
    return {
        mapPostTransferPixPixBodyToTransferPixV3Api: mapPixBodyToV3Api,
    };
}
